import Styles from './styles.module.css';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import { jobPostingYearDoc, ONBOARDING_JOB_POSTING_YEAR } from '../../2.jobPostings/jobPostingRef';
import Navigation from "../../2.jobPostings/edit/navigation/index";
import Info from "../../2.jobPostings/edit/2.edit/2.info";
import Employment from "../../2.jobPostings/edit/2.edit/5.20-employment";
import Employment18 from "../../2.jobPostings/edit/2.edit/6.18-employment";
import Employment17 from "../../2.jobPostings/edit/2.edit/7.17-employment";
import Benefit from "../../2.jobPostings/edit/2.edit/8-benefit";
import Target from "../../2.jobPostings/edit/2.edit/4.target";
import ApplicationInfo from "../../2.jobPostings/edit/2.edit/9.applicationInfo";
import Pamphlet from "./2.edit/10.pamphlet";
import BackCaution from "./backCaution/index";
import Preview from "./preview/index";
import Summary from './2.edit/1.summary';
import Stores from '../../3.recruit/2.edit/2.store';
import Confirm from './confirm/index';
import { defaultSummaryData, defaultInfo, defaultApplicationInfo, defaultPamphlet, formatSummary, formatInfo, formatApplicationInfo, formatPamphlet, defaultBenefit, defaultEmployment20, defaultEmployment18, defaultEmployment17, defaultTarget, formatTarget, formatBenefit, formatEmployment20, formatEmployment18, formatEmployment17, defaultHashTagsData, formatHashTags } from "../../../../type";
import { useAppSelector } from 'src/salon/app/hook';
import HashTag from "../../2.jobPostings/edit/2.edit/11.hashTag";
import { PiCheckCircleFill } from "react-icons/pi";
import { VscChevronRight } from "react-icons/vsc";

const MOBILE_NAV_ITEMS = [
  { id: 1, label: "魅力" },
  { id: 2, label: "企業情報" },
  { id: 3, label: "店舗情報" },
  { id: 4, label: "募集区分" },
  { id: 5, label: "雇用条件(20歳卒)" },
  { id: 6, label: "雇用条件(18歳卒)", targetCondition: "高専(18歳卒)" },
  { id: 7, label: "雇用条件(17歳卒)", targetCondition: "高専(17歳卒)" },
  { id: 8, label: "福利厚生" },
  { id: 9, label: "採用情報" },
  { id: 10, label: "パンフレット" },
  { id: 11, label: "ハッシュタグ" },
];

function checkProgressMobile(progress: boolean[], target: string[]) {
  return progress.slice(0, 11).every((item, index) => {
    if (!target?.includes('高専(18歳卒)') && index === 5) return true;
    if (!target?.includes('高専(17歳卒)') && index === 6) return true;
    return Boolean(item);
  });
}

const School: React.FC = () => {

  const company = useAppSelector((state) => state.company.company);
  const db = getFirestore();

  const renderCount = useRef(0);
  renderCount.current += 1;

  const savedData = useRef<any>(null);
  const navRef = useRef<HTMLDivElement>(null);

  const [documentId, setDocumentId] = useState<string>("");
  const [navigation, setNavigation] = useState<number>(1);
  const [mobileNavOpen, setMobileNavOpen] = useState<boolean>(false);

  // Windows(desktop/index.tsxで全体にzoom:0.8がかかっている)では、
  // 内側の要素がCSSのmin-height:100vhをそのまま使うとzoomで縮小された分
  // 画面下部が余って背景が途切れるため、ズーム分を逆算した高さで
  // 上書きする(desktop/index.tsxのMainラッパーと同じ対処)。
  const isWindows = navigator.userAgent.includes("Windows");

  const [progress, setProgress] = useState<boolean[]>(Array(11).fill(false));
  const [changeData, setChangeData] = useState<boolean>(false);
  const [backCaution, setBackCaution] = useState<number>(0);

  const [summary, setSummary] = useState(defaultSummaryData);
  const memoizedSummary = useMemo(() => summary, [summary]);

  const [info, setInfo] = useState(defaultInfo);
  const memoizedInfo = useMemo(() => info, [info]);

  const [target, setTarget] = useState(defaultTarget);
  const memoizedTarget = useMemo(() => target, [target]);

  const [benefit, setBenefit] = useState(defaultBenefit);
  const memoizedBenefit = useMemo(() => benefit, [benefit]);

  const [employment20, setEmployment20] = useState(defaultEmployment20);
  const memoizedEmployment20 = useMemo(() => employment20, [employment20]);

  const [employment18, setEmployment18] = useState(defaultEmployment18);
  const memoizedEmployment18 = useMemo(() => employment18, [employment18]);

  const [employment17, setEmployment17] = useState(defaultEmployment17);
  const memoizedEmployment17 = useMemo(() => employment17, [employment17]);

  const [applicationInfo, setApplicationInfo] = useState(defaultApplicationInfo);
  const memoizedApplicationInfo = useMemo(() => applicationInfo, [applicationInfo]);

  const [pamphlet, setPamphlet] = useState(defaultPamphlet);
  const memoizedPamphlet = useMemo(() => pamphlet, [pamphlet]);

  const [hashTag, setHashTag] = useState(defaultHashTagsData);
  const memoizedHashTag = useMemo(() => hashTag, [hashTag]);

  const [storeImageLocal, setStoreImageLocal] = useState<string>("");

  const [confirm, setConfirm] = useState<boolean>(false);

  // 新規オンボーディングが対象とする求人票の卒業年度(jobPostingRef.tsで一元管理)。
  const companyId = company?.id ?? '';
  const year = ONBOARDING_JOB_POSTING_YEAR;

  const [oldData, setOldData] = useState<any>(null);
  const [newData, setNewData] = useState<any>(null);

  // -------------------------
  // Firestore同期 (1): summary / store / pamphlet ← recruits/{companyId}_2027 (3.recruitと共有)
  // -------------------------
  useEffect(() => {
    if (!company?.id) return;

    const id = company.id + '_2027';
    setDocumentId(id);

    const docRef = doc(db, "recruits", id);

    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      setOldData(docSnap.exists() ? docSnap.data() : {});
    });

    return () => unsubscribe();
  }, [company.id]);

  // -------------------------
  // Firestore同期 (2): info / target / employment* / benefit / applicationInfo / hashTag
  //                     ← recruits/{companyId}_2027/jobPostings/{year} (年度別・求人票専有)
  // -------------------------
  useEffect(() => {
    if (!companyId) return;

    const newRef = jobPostingYearDoc(db, companyId, year);

    // まだドキュメントが存在しない場合(新規会社)に備えて空ドキュメントを用意しておく。
    // merge:true なので既存データは壊さない。
    setDoc(newRef, {}, { merge: true }).catch((error) => {
      console.error('求人票データの初期化に失敗しました:', error);
    });

    const unsubscribe = onSnapshot(newRef, (docSnap) => {
      setNewData(docSnap.exists() ? docSnap.data() : {});
    });

    return () => unsubscribe();
  }, [companyId, year]);

  // -------------------------
  // (1)(2)の同期結果を合成してフォームの状態に反映
  // -------------------------
  useEffect(() => {
    if (oldData === null || newData === null) return;

    const statusKeys = [
      oldData.summary?.isCompleted,
      newData.info?.isCompleted,
      oldData.store?.isCompleted,
      newData.target?.isCompleted,
      newData.employment20?.isCompleted,
      newData.employment18?.isCompleted,
      newData.employment17?.isCompleted,
      newData.benefit?.isCompleted,
      newData.applicationInfo?.isCompleted,
      oldData.pamphlet?.isCompleted,
      newData.hashTag?.isCompleted,
    ];

    setProgress(statusKeys);

    const formatted = {
      summary: formatSummary(oldData),
      pamphlet: formatPamphlet(oldData),
      info: formatInfo(newData),
      target: formatTarget(newData),
      employment20: formatEmployment20(newData),
      employment18: formatEmployment18(newData),
      employment17: formatEmployment17(newData),
      applicationInfo: formatApplicationInfo(newData),
      benefit: formatBenefit(newData),
      hashTag: formatHashTags(newData),
    };

    savedData.current = formatted;

    setSummary(formatted.summary);
    setInfo(formatted.info);
    setTarget(formatted.target);
    setEmployment20(formatted.employment20);
    setEmployment18(formatted.employment18);
    setEmployment17(formatted.employment17);
    setApplicationInfo(formatted.applicationInfo);
    setBenefit(formatted.benefit);
    setPamphlet(formatted.pamphlet);
    setHashTag(formatted.hashTag);
  }, [oldData, newData]);

  const resetToSaved = () => {
    if (!savedData.current) return;
    const d = savedData.current;
    setSummary(d.summary);
    setInfo(d.info);
    setTarget(d.target);
    setEmployment20(d.employment20);
    setEmployment18(d.employment18);
    setEmployment17(d.employment17);
    setApplicationInfo(d.applicationInfo);
    setBenefit(d.benefit);
    setPamphlet(d.pamphlet);
    setHashTag(d.hashTag);
  };

  const handleMobilePublish = () => {
    const buttons = navRef.current?.querySelectorAll('button');
    if (buttons && buttons.length > 0) {
      const confirmBtn = buttons[buttons.length - 1] as HTMLButtonElement;
      confirmBtn.click();
    }
    setMobileNavOpen(false);
  };

  return (
    <>
    <div className={Styles.plan} style={{ minHeight: isWindows ? '125vh' : undefined }}>
      <div className={Styles.inner}>

      <p className={Styles.kicker}>STEP 3</p>
      <h1 className={Styles.title}>{year}年度の求人情報を作成</h1>
      <p className={Styles.lead}>
        学生に届く求人票の内容を入力します。<br />
        ご記載いただいた内容が学校へ送付されますので、必ず完了前にご確認ください。
      </p>

      {confirm ?
        <Confirm companyId={companyId} year={year} target={target} setConfirm={setConfirm} />
      :
        <div className={Styles.box}>

          {/* デスクトップ用ナビゲーション（モバイルでは画面外に退避） */}
          <div ref={navRef} className={Styles.desktop_nav}>
            <Navigation
              summary={memoizedSummary}
              info={memoizedInfo}
              target={memoizedTarget}
              benefit={memoizedBenefit}
              employment20={memoizedEmployment20}
              employment18={memoizedEmployment18}
              employment17={memoizedEmployment17}
              applicationInfo={memoizedApplicationInfo}
              progress={progress} companyId={companyId} year={year}
              changeData={changeData} navigation={navigation} setNavigation={setNavigation} setBackCaution={setBackCaution}
              setConfirm={setConfirm} />
          </div>

          {/* モバイル・タブレット用ナビゲーションバー */}
          <div className={Styles.mobile_nav_bar} onClick={() => setMobileNavOpen(true)}>
            <div className={Styles.mobile_nav_bar_left}>
              <p className={Styles.mobile_nav_step}>{navigation} / 11</p>
              <p className={Styles.mobile_nav_label}>
                {MOBILE_NAV_ITEMS.find(i => i.id === navigation)?.label}
              </p>
            </div>
            <VscChevronRight className={Styles.mobile_nav_chevron} />
          </div>

          <div className={Styles.center}>

            {navigation === 1 ?
            <Summary
              documentId={documentId}
              setChangeData={setChangeData}
              summary={memoizedSummary} setSummary={setSummary} />
            : navigation === 2 ?
            <Info
              companyId={companyId} year={year} setChangeData={setChangeData}
              info={memoizedInfo} setInfo={setInfo} />
            : navigation === 3 ?
            <Stores documentId={documentId} setStoreImageLocal={setStoreImageLocal} />
            : navigation === 4 ?
            <Target
              companyId={companyId} year={year} setChangeData={setChangeData}
              target={memoizedTarget} setTarget={setTarget} />
            : navigation === 5 ?
            <Employment
              graduateAge={20}
              companyId={companyId} year={year} setChangeData={setChangeData}
              info={info}
              employment17={memoizedEmployment17} setEmployment17={setEmployment17}
              employment18={memoizedEmployment18} setEmployment18={setEmployment18}
              employment20={memoizedEmployment20} setEmployment20={setEmployment20} />
            : navigation === 6 ?
            <Employment18
              companyId={companyId} year={year} setChangeData={setChangeData}
              info={info}
              employment17={memoizedEmployment17} setEmployment17={setEmployment17}
              employment18={memoizedEmployment18} setEmployment18={setEmployment18}
              employment20={memoizedEmployment20} setEmployment20={setEmployment20} />
            : navigation === 7 ?
            <Employment17
              companyId={companyId} year={year} setChangeData={setChangeData}
              info={info}
              employment17={memoizedEmployment17} setEmployment17={setEmployment17}
              employment18={memoizedEmployment18} setEmployment18={setEmployment18}
              employment20={memoizedEmployment20} setEmployment20={setEmployment20} />
            : navigation === 8 ?
            <Benefit
              info={memoizedInfo}
              companyId={companyId} year={year} setChangeData={setChangeData}
              benefit={memoizedBenefit} setBenefit={setBenefit}
              employment20={memoizedEmployment20} />
            : navigation === 9 ?
            <ApplicationInfo
              companyId={companyId} year={year} setChangeData={setChangeData}
              info={info}
              applicationInfo={memoizedApplicationInfo} setApplicationInfo={setApplicationInfo} />
            : navigation === 10 ?
            <Pamphlet
              documentId={documentId} setChangeData={setChangeData}
              pamphlet={memoizedPamphlet} setPamphlet={setPamphlet} />
            : navigation === 11 ?
            <HashTag
              companyId={companyId} year={year}
              setChangeData={setChangeData}
              hashTag={memoizedHashTag} setHashTag={setHashTag} />
            : <></>}

            <div style={{height: '30px'}}></div>

          </div>

          {/* デスクトップ用プレビュー（モバイルでは非表示） */}
          <div className={Styles.desktop_preview}>
            <Preview
              navigation={navigation}
              documentId={documentId}
              storeImageLocal={storeImageLocal}

              summary={memoizedSummary}
              info={memoizedInfo}
              target={memoizedTarget}
              benefit={memoizedBenefit}
              employment20={memoizedEmployment20}
              applicationInfo={memoizedApplicationInfo} />
          </div>
        </div>
      }

      </div>
    </div>

    {/* モバイル・タブレット用ナビゲーションモーダル */}
    {mobileNavOpen && (
      <div className={Styles.mobile_modal_overlay} onClick={() => setMobileNavOpen(false)}>
        <div className={Styles.mobile_modal} onClick={e => e.stopPropagation()}>
          <div className={Styles.mobile_modal_header}>
            <p className={Styles.mobile_modal_title}>求人票の編集</p>
            <button className={Styles.mobile_modal_close} onClick={() => setMobileNavOpen(false)}>✕</button>
          </div>

          {MOBILE_NAV_ITEMS.map(({ id, label, targetCondition }) => {
            const isActive = navigation === id;
            const isDisabled = targetCondition && !target?.target?.includes(targetCondition);

            return (
              <div
                key={id}
                className={Styles.mobile_modal_item}
                style={{
                  backgroundColor: isActive ? '#EBEBEB' : '',
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  opacity: isDisabled ? 0.4 : 1,
                }}
                onClick={() => {
                  if (isDisabled) return;
                  if (changeData && navigation !== id) {
                    setBackCaution(id);
                  } else {
                    setNavigation(id);
                  }
                  setMobileNavOpen(false);
                }}
              >
                <p style={{ fontWeight: isActive ? 'bold' : '400' }}>
                  {id}. {label}
                </p>
                {progress[id - 1] ? (
                  <PiCheckCircleFill className={Styles.mobile_modal_save} />
                ) : (
                  <VscChevronRight className={Styles.mobile_modal_unsave} />
                )}
              </div>
            );
          })}

          <button
            className={Styles.mobile_modal_confirm_btn}
            onClick={handleMobilePublish}
            style={checkProgressMobile(progress, target.target)
              ? { cursor: 'pointer' }
              : { backgroundColor: '#fafafa', color: '#cccccc', border: '1px solid #EBEBEB', boxShadow: 'none', fontWeight: '400', cursor: 'default' }
            }
          >
            確定
          </button>
        </div>
      </div>
    )}

    {backCaution !== 0 && (
      <BackCaution backCaution={backCaution} setBackCaution={setBackCaution} setNavigation={setNavigation} setChangeData={setChangeData} resetToSaved={resetToSaved} />
    )}
    </>
  );
}

export default School;
